import { Card, Col, Container, Row } from "reactstrap";
import { useState } from "react";
import { Breadcrumbs, P } from "../../../AbstractElements";
import { useParams } from "react-router-dom";
import { CRUDPermissions } from "../../../Types/Common/Access";

// Cards
import EmployeeProfile from "./EmployeeProfile";
import EmployeeProfileTabs from "./EmployeeProfileTabs";

interface UserAccessProps {
  access: CRUDPermissions;
}

const EmployeeContainer: React.FC<UserAccessProps> = ({ access }) => {
  const { emp_no } = useParams<{ emp_no: string }>();
  const EmpNo = emp_no ? atob(decodeURIComponent(emp_no)) : "";

  return (
    <>
      <Breadcrumbs
        mainTitle={`Employee  No. ${EmpNo}`}
        parent="Workforce / Employee Directory"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <div className="user-profile">
              <EmployeeProfile EmpNo={EmpNo} access={access} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <EmployeeProfileTabs EmpNo={EmpNo} access={access} />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EmployeeContainer;
